var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowRight = function SvgLongArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    color: "#BDBDBD",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.13 8.092a.85.85 0 0 0 0-1.201L8.887 2.649a.85.85 0 0 0-1.201 1.2l2.797 2.795H2.348a.848.848 0 1 0 0 1.697h8.133l-2.792 2.795a.85.85 0 0 0 1.2 1.201l4.243-4.242z"
  })));
};
export default SvgLongArrowRight;